/****************************************************************************
 ** @license
 ** This demo file is part of yFiles for HTML 2.4.0.3.
 ** Copyright (c) 2000-2021 by yWorks GmbH, Vor dem Kreuzberg 28,
 ** 72070 Tuebingen, Germany. All rights reserved.
 **
 ** yFiles demo files exhibit yFiles for HTML functionalities. Any redistribution
 ** of demo files in source code or binary form, with or without
 ** modification, is not permitted.
 **
 ** Owners of a valid software license for a yFiles for HTML version that this
 ** demo is shipped with are allowed to use the demo source code as basis
 ** for their own yFiles for HTML powered applications. Use of such programs is
 ** governed by the rights and conditions as set out in the yFiles for HTML
 ** license agreement.
 **
 ** THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESS OR IMPLIED
 ** WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 ** MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN
 ** NO EVENT SHALL yWorks BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 ** SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 ** TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 ** PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 ** LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 ** NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 ** SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 **
 ***************************************************************************/
// @ts-ignore
import React, { Component } from 'react'
import './GraphOverviewComponent.css'
import { GraphComponent, GraphOverviewComponent } from 'yfiles'

interface ReactGraphOverviewComponentProps {
  graphComponent: GraphComponent
}

export default class ReactGraphOverviewComponent extends Component<ReactGraphOverviewComponentProps> {
  private readonly div: React.RefObject<HTMLDivElement>
  private readonly graphComponent: GraphComponent
  private graphOverviewComponent: GraphOverviewComponent | null = null

  constructor(props: ReactGraphOverviewComponentProps) {
    super(props)
    this.div = React.createRef<HTMLDivElement>()
    this.graphComponent = props.graphComponent
  }

  async componentDidMount(): Promise<void> {
    this.graphOverviewComponent = new GraphOverviewComponent(
      '#graph-overview-component',
      this.graphComponent
    )
  }

  render() {
    return (
      <div className="overview-container">
        <div className="overview-title">Overview</div>
        <div id="graph-overview-component" ref={this.div} />
      </div>
    )
  }
}
